import styled from 'styled-components';

export const LogoLink = styled.a<{
  $display: string;
  $justifyContent: string;
  $marginTop: string;
}>`
  display: ${({ $display }) => $display};
  justify-content: ${({ $justifyContent }) => $justifyContent};
  margin-top: ${({ $marginTop }) => $marginTop}px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 4px;
`;
